import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import HomePage from './pages/HomePage';
import ProductPage from './pages/ProductPage';
import Header from './components/Header';
import FloatingAppBar from './components/FloatingAppBar';
import AnimationController from './components/AnimationController';
import NavigationFeedback from './components/NavigationFeedback';
import { useI18n } from './i18n';

// Top level application component.  It defines the
// available routes and exposes a scroll handler to the
// header so navigation items can smoothly scroll to
// particular sections on the home page.  When navigating
// between pages the header remains consistent.
export default function App() {
  const location = useLocation();
  const { t } = useI18n();

  return (
    <div className="app-shell">
      <AnimationController />
      <NavigationFeedback />
      <Header/>
      <Routes location={location.pathname}>
        <Route path="/" element={<HomePage/>} />
        <Route path="/product" element={<ProductPage />} />
      </Routes>
      <FloatingAppBar />
      <footer className="site-footer">
        <div>
          <img src="/assets/logo-clean.png" alt={t('brand.companyName')} />
          <span>{t('brand.footerTagline')}</span>
        </div>
        <a href="tel:+79043032224">+7 (904) 303-22-24</a>
      </footer>
    </div>
  );
}
